import { render, staticRenderFns } from "./close.vue?vue&type=template&id=2a643761&scoped=true&lang=pug&"
var script = {}
import style0 from "./close.vue?vue&type=style&index=0&id=2a643761&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a643761",
  null
  
)

export default component.exports